import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';

import { environment } from './../../../environments/environment';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

//#region Methods which are defined in the src/assets/Me.js files.
declare function getCurrentUserEmail(): string;

@Injectable({
  providedIn: 'root'
})
export class AuthenticationProvider {

  private Api_URL: string = environment.apiUrl + `User/`;

  constructor(
    private _httpClient: HttpClient) {   

  }

  public getCurrentUser(): string {
    return getCurrentUserEmail();
  }

  public isApproval(currentUser: string): Observable<boolean> {
    return this._httpClient
      .get<boolean>(this.Api_URL + `isApproval?currentUser=` + currentUser);    
  }

  public isAdmin(currentUser: string): Observable<boolean> {
    return this._httpClient
      .get<boolean>(this.Api_URL + `isAdmin?currentUser=` + currentUser);    
  }
  
}
